<bb-ofw-loan *ngIf="route.url === '/ofw-loan' && isPage(0)|async; else seamanLoan"></bb-ofw-loan>
<ng-template #seamanLoan>
  <bb-seaman-loan *ngIf="route.url === '/seaman-loan' && isPage(0)|async; else others"></bb-seaman-loan>
</ng-template>
<ng-template #others>
  <section fxLayout="column" fxLayoutGap="16px">
    <bb-top-banner></bb-top-banner>
    <bb-loan-application></bb-loan-application>
    <bb-product-advantage></bb-product-advantage>
    <bb-customer-statement></bb-customer-statement>
  </section>
</ng-template>
